import * as components from './components';

export default [
  {
    path: '/',
    component: components.Dashboard,
    name: 'dashboard'
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/dashboard/routes.js